import SuperAdminUXWizard from "./SuperAdminUXWizard";

export default SuperAdminUXWizard;
